// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"passwords_wrapper_3tHrt","inner":"passwords_inner_1w9dl","top":"passwords_top_17W12","body":"passwords_body_1Vua8","site":"passwords_site_2jx4C"};